import "./RecentPortfolioComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {RecentPortfolioService} from "../../../../services/favourite-portfolios/RecentPortfolioService";
import {Observable, ReplaySubject} from "rxjs";
import {RecentPortfolio} from "../../../../services/favourite-portfolios/models/RecentPortfolio";
import {LocalStorageService} from "../../../../types/NgStorage";
import {ComponentCallback} from "../../../../types/AngularJS";

export const RecentPortfolios = "tfRecentPortfolios";

export function recentPortfolios(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/recent/RecentPortfolioComponent.html`,
        bindings: {
            onPortfolioClicked: "&"
        },
        controllerAs: "ctrl",
        controller: RecentPortfolioComponentController
    };
}

const FavouritesStorageKey = "tfSidebarFavouritesHidden";
const RecentPortfoliosStorageKey = "tfSidebarRecentAccountsHidden";

export class RecentPortfolioComponentController implements IOnInit, IOnDestroy {

    public readonly onPortfolioClicked: ComponentCallback;

    public favourites: Observable<Array<RecentPortfolio>>;
    public recent: Observable<Array<RecentPortfolio>>;

    public hideFavourites = false;
    public hideRecent = false;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly recentPortfolioService: RecentPortfolioService,
                       private readonly $localStorage: LocalStorageService) {

    }

    public $onInit(): void {
        this.favourites = this.recentPortfolioService
                              .favourites
                              .takeUntil(this.destroyed$);
        this.recent = this.recentPortfolioService
                          .recent
                          .takeUntil(this.destroyed$);
        this.initExpansionState();
    }

    private initExpansionState() {
        const storedFavourites = this.$localStorage[FavouritesStorageKey];
        if (storedFavourites != null) {
            this.hideFavourites = storedFavourites;
        }
        const storedRecent = this.$localStorage[RecentPortfoliosStorageKey];
        if (storedRecent != null) {
            this.hideRecent = storedRecent;
        }
    }

    public toggleFavourites() {
        this.hideFavourites = !this.hideFavourites;
        this.$localStorage[FavouritesStorageKey] = this.hideFavourites;
    }

    public toggleRecent() {
        this.hideRecent = !this.hideRecent;
        this.$localStorage[RecentPortfoliosStorageKey] = this.hideRecent;
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
